import "./icon.css";

export function Icon(props) {
  function appLogo() {
    let bankName = document.getElementById("bank-name").innerHTML;
    bankName = bankName ? bankName : "default";
    switch (bankName) {
      case "zenith":
        return (
          <img
            className="app-logo"
            src="/bank-images/zenith-bank-logo.png"
            alt="zenith logo"
          />
        );
      default:
        return (
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 5745.8 5745.8"
          >
            <g>
              <circle fill="#FBB416" cx="3015.8" cy="3153.4" r="566.8" />
              <path
                fill="#0371AC"
                d="M3830.6,2889c0-30.4,0-60.8-10.2-91.1v-10.2c-30.5-587.6-517.5-1043.4-1106.2-1043.4
		c-608.8,0-1106,496.3-1106,1104.1c0,476.1,304.4,881.3,730.6,1033.2c121.8,40.6,243.5,60.8,375.5,60.8c71.1,0,130.9,0,213.1,0
		c10.2,0,20.4,0,30.4,0c218.4,0,872.7,0,872.7,0S3840.6,3152.3,3830.6,2889z M2734.6,3476.6c-355.1,10.2-639.3-263.4-639.3-618
		c0-344.5,284.2-638.2,629.1-638.2c314.6,0,608.9,283.7,618.9,607.8C3363.7,3172.7,3089.7,3466.4,2734.6,3476.6z"
              />
            </g>
          </svg>
        );
    }
  }

  switch (props.icon) {
    case "menu-icon":
      return (
        <svg
          width="28"
          height="17"
          viewBox="0 0 28 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0H28V2.38H0V0ZM0 7.14035H28V9.52035H0V7.14035ZM17.1111 14.2801H0V16.6601H17.1111V14.2801Z"
            fill="black"
          />
        </svg>
      );
    case "question-circle":
      return (
        <i className="pi pi-question-circle" style={{ color: props.color }} />
      );
    case "log-out":
      return (
        <svg
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 4.26935V15.3244C0 16.3423 0.41841 17.247 1.08787 17.9539C1.75732 18.6324 2.62204 19 3.62622 19H9.09344V16.7098H3.62622C2.87308 16.7098 2.28731 16.0878 2.28731 15.3244V4.26935C2.28731 3.50595 2.87308 2.9122 3.62622 2.9122H9.09344V0.59375H3.62622C2.62204 0.59375 1.75732 0.989583 1.08787 1.66815C0.41841 2.375 0 3.25149 0 4.26935ZM5.99721 7.60565V12.0164C5.99721 12.5253 6.44351 12.9494 6.94561 12.9494H11.9944V16.4271C11.9944 16.7381 12.1618 16.9926 12.4407 17.1339C12.5523 17.1622 12.6639 17.1622 12.7197 17.1622C12.9149 17.1622 13.0823 17.1057 13.2218 16.9643L19.7768 10.3199C20.0837 10.0655 20.0558 9.55655 19.7768 9.27381L13.2218 2.65774C12.8312 2.23363 11.9944 2.4881 11.9944 3.16667V6.67262H6.94561C6.44351 6.67262 5.99721 7.09673 5.99721 7.60565Z"
            fill="#0B3275"
          />
        </svg>
      );
    case "logo":
      return appLogo();
    case "merchant":
      return <i className="pi pi-briefcase" style={{ color: props.color }} />;
    case "dashboard":
      return <i className="pi pi-chart-bar" style={{ color: props.color }} />;
    case "server-health":
      // return <i className="pi pi-cart-plus" style={{ color: props.color }} />;
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="800px"
          height="800px"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M2 18C2 17.0681 2 16.6022 2.15224 16.2346C2.35523 15.7446 2.74458 15.3552 3.23463 15.1522C3.60218 15 4.06812 15 5 15H19C19.9319 15 20.3978 15 20.7654 15.1522C21.2554 15.3552 21.6448 15.7446 21.8478 16.2346C22 16.6022 22 17.0681 22 18C22 18.9319 22 19.3978 21.8478 19.7654C21.6448 20.2554 21.2554 20.6448 20.7654 20.8478C20.3978 21 19.9319 21 19 21H5C4.06812 21 3.60218 21 3.23463 20.8478C2.74458 20.6448 2.35523 20.2554 2.15224 19.7654C2 19.3978 2 18.9319 2 18Z"
            stroke={props.color}
            strokeWidth="1.5"
          />
          <path
            d="M2 12C2 11.0681 2 10.6022 2.15224 10.2346C2.35523 9.74458 2.74458 9.35523 3.23463 9.15224C3.60218 9 4.06812 9 5 9H19C19.9319 9 20.3978 9 20.7654 9.15224C21.2554 9.35523 21.6448 9.74458 21.8478 10.2346C22 10.6022 22 11.0681 22 12C22 12.9319 22 13.3978 21.8478 13.7654C21.6448 14.2554 21.2554 14.6448 20.7654 14.8478C20.3978 15 19.9319 15 19 15H5C4.06812 15 3.60218 15 3.23463 14.8478C2.74458 14.6448 2.35523 14.2554 2.15224 13.7654C2 13.3978 2 12.9319 2 12Z"
            stroke={props.color}
            strokeWidth="1.5"
          />
          <path
            d="M2 6C2 5.06812 2 4.60218 2.15224 4.23463C2.35523 3.74458 2.74458 3.35523 3.23463 3.15224C3.60218 3 4.06812 3 5 3H19C19.9319 3 20.3978 3 20.7654 3.15224C21.2554 3.35523 21.6448 3.74458 21.8478 4.23463C22 4.60218 22 5.06812 22 6C22 6.93188 22 7.39782 21.8478 7.76537C21.6448 8.25542 21.2554 8.64477 20.7654 8.84776C20.3978 9 19.9319 9 19 9H5C4.06812 9 3.60218 9 3.23463 8.84776C2.74458 8.64477 2.35523 8.25542 2.15224 7.76537C2 7.39782 2 6.93188 2 6Z"
            stroke={props.color}
            strokeWidth="1.5"
          />
          <circle cx="5" cy="12" r="1" fill={props.color} />
          <circle cx="5" cy="6" r="1" fill={props.color} />
          <circle cx="5" cy="18" r="1" fill={props.color} />
        </svg>
      );
    case "service-monitoring":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="800px"
          height="800px"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            opacity="0.5"
            d="M22 10.5V12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2H13.5"
            stroke="#1C274C"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M7 14L8.79689 11.8437C9.50894 10.9893 9.86496 10.562 10.3333 10.562C10.8017 10.562 11.1577 10.9893 11.8698 11.8437L12.1302 12.1563C12.8423 13.0107 13.1983 13.438 13.6667 13.438C14.135 13.438 14.4911 13.0107 15.2031 12.1563L17 10"
            stroke="#1C274C"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="19" cy="5" r="3" stroke="#1C274C" strokeWidth="1.5" />
        </svg>
      );
    case "white-logo":
      return (
        <svg
          width="129"
          height="129"
          viewBox="0 0 129 129"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d)">
            <path
              d="M64.5292 84H64.2754C47.8643 83.9582 36.8672 80.5711 34.5832 78.4803C32.1722 76.3477 29 65.3082 29 49C29 32.7336 32.1722 21.6523 34.5832 19.5197C36.8672 17.4289 47.9066 14.0418 64.2754 14H64.5292C80.9403 14.0418 91.9374 17.4289 94.2214 19.5197C96.6323 21.6523 99.8046 32.7336 99.8046 49C99.8046 65.2664 96.6323 76.3477 94.2214 78.4803C91.9374 80.6129 80.9403 84 64.5292 84Z"
              fill={props.color}
            />
          </g>
          <path
            d="M80.7283 51.0908L79.3748 34.7407H71.2116C71.2116 34.7407 64.994 47.3273 64.4441 49.0418H64.3595L57.8036 34.7407H49.598L48.2445 48.9164L47.1025 63.3011H52.0935C54.2507 63.3011 55.0966 62.3811 55.2658 60.123C55.2658 60.123 56.1117 46.951 55.9848 45.0275H56.0694L56.3232 45.9056C56.6616 47.0764 61.3142 58.325 61.3142 58.325H67.4472C67.4472 58.325 72.0998 47.2437 72.6919 45.0275H72.7765L73.4956 60.123C73.6648 62.3811 74.553 63.3011 76.6678 63.3011H81.6588L80.7283 51.0908Z"
            fill={props.color}
          />
          <defs>
            <filter
              id="filter0_d"
              x="0.198143"
              y="0.79915"
              width="128.408"
              height="127.604"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="15.601" />
              <feGaussianBlur stdDeviation="14.4009" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0156863 0 0 0 0 0.505882 0 0 0 0 0.960784 0 0 0 0.26 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      );
    case "circular-cancel":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 12.5C0 5.6075 5.6075 0 12.5 0C19.3925 0 25 5.6075 25 12.5C25 19.3937 19.3925 25 12.5 25C5.6075 25 0 19.3937 0 12.5ZM16.6161 18.3837L18.3836 16.6162L14.2673 12.5L18.3836 8.38373L16.6161 6.61623L12.4998 10.7325L8.38356 6.61623L6.61606 8.38373L10.7323 12.5L6.61606 16.615L8.38356 18.3825L12.4998 14.2675L16.6161 18.3837Z"
            fill="#D45866"
          />
        </svg>
      );
    case "cancel":
      return (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5871 12.5996L9.4875 7.5L14.5871 2.40043C15.1376 1.84986 15.1376 0.963491 14.5871 0.412925C14.0365 -0.137642 13.1501 -0.137642 12.5996 0.412925L7.5 5.5125L2.40043 0.412925C1.84986 -0.137642 0.963491 -0.137642 0.412925 0.412925C-0.137642 0.963491 -0.137642 1.84986 0.412925 2.40043L5.5125 7.5L0.412925 12.5996C-0.137642 13.1501 -0.137642 14.0365 0.412925 14.5871C0.963491 15.1376 1.84986 15.1376 2.40043 14.5871L7.5 9.4875L12.5996 14.5871C13.1501 15.1376 14.0365 15.1376 14.5871 14.5871C15.1337 14.0365 15.1337 13.1462 14.5871 12.5996Z"
            fill="#D45866"
          />
        </svg>
      );
    case "cancel-success":
      return (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5871 12.5996L9.4875 7.5L14.5871 2.40043C15.1376 1.84986 15.1376 0.963491 14.5871 0.412925C14.0365 -0.137642 13.1501 -0.137642 12.5996 0.412925L7.5 5.5125L2.40043 0.412925C1.84986 -0.137642 0.963491 -0.137642 0.412925 0.412925C-0.137642 0.963491 -0.137642 1.84986 0.412925 2.40043L5.5125 7.5L0.412925 12.5996C-0.137642 13.1501 -0.137642 14.0365 0.412925 14.5871C0.963491 15.1376 1.84986 15.1376 2.40043 14.5871L7.5 9.4875L12.5996 14.5871C13.1501 15.1376 14.0365 15.1376 14.5871 14.5871C15.1337 14.0365 15.1337 13.1462 14.5871 12.5996Z"
            fill="#389e0d"
          />
        </svg>
      );
    case "circular-success":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 104 104"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M74.9865 35.5001C76.5734 37.087 76.5734 39.6594 74.9865 41.2455L47.7328 64.4999C46.1459 66.0861 43.5743 66.0861 41.9874 64.4999L31.5 53C29.9131 51.4139 30.5 49.5 30.5 49.5C31.5 48.5 33.1721 48.1938 34.7582 49.7807L44.8597 59.8822L69.241 35.5001C70.8279 33.9139 73.4003 33.9139 74.9865 35.5001ZM104 52C104 80.743 80.739 104 52 104C23.257 104 0 80.739 0 52C0 23.257 23.261 0 52 0C80.743 0 104 23.261 104 52ZM99 52C99 27.748 76.2488 5 52 5C27.748 5 4.5 26.7512 4.5 51C4.5 75.252 27.7512 99 52 99C76.252 99 99 76.2488 99 52Z"
            fill="#389e0d"
          />
        </svg>
      );
    case "config":
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 11.5C11.8284 11.5 12.5 10.8284 12.5 10C12.5 9.17157 11.8284 8.5 11 8.5C10.1716 8.5 9.5 9.17157 9.5 10C9.5 10.8284 10.1716 11.5 11 11.5Z"
            fill={props.color}
          />
          <path
            d="M20.89 8.32L20.1 5.8C20.0147 5.50876 19.8717 5.23767 19.6793 5.00292C19.487 4.76817 19.2493 4.57456 18.9806 4.43364C18.7118 4.29272 18.4174 4.20737 18.1149 4.1827C17.8124 4.15802 17.5081 4.19451 17.22 4.29L16.88 4.4C16.6137 4.48805 16.33 4.51039 16.0531 4.46511C15.7763 4.41984 15.5145 4.3083 15.29 4.14L15.18 4.06C14.961 3.89237 14.7845 3.67562 14.6646 3.42723C14.5448 3.17884 14.485 2.90575 14.49 2.63V2.35C14.4949 1.72202 14.2503 1.11779 13.81 0.67C13.6006 0.458452 13.3515 0.290362 13.0769 0.175383C12.8023 0.0604042 12.5077 0.000802192 12.21 0H9.66004C9.04821 0.00790627 8.46428 0.257192 8.03538 0.693583C7.60648 1.12997 7.36735 1.71813 7.37003 2.33V2.57C7.36907 2.86027 7.30299 3.14663 7.17665 3.40796C7.05031 3.6693 6.86693 3.89895 6.64003 4.08L6.51004 4.18C6.25938 4.36962 5.9662 4.49516 5.65599 4.5457C5.34578 4.59624 5.02792 4.57025 4.73003 4.47C4.45645 4.37533 4.1665 4.33715 3.87773 4.35777C3.58897 4.3784 3.30739 4.4574 3.05003 4.59C2.78209 4.72299 2.54438 4.90969 2.3517 5.1385C2.15901 5.36731 2.01548 5.63333 1.93003 5.92L1.11003 8.52C0.919877 9.1062 0.968643 9.74374 1.24574 10.2942C1.52284 10.8447 2.00591 11.2636 2.59003 11.46H2.75003C3.01949 11.561 3.26134 11.7241 3.45594 11.9361C3.65054 12.148 3.79241 12.4029 3.87003 12.68L3.93003 12.84C4.04151 13.1461 4.07879 13.4743 4.03881 13.7977C3.99883 14.121 3.88272 14.4302 3.70003 14.7C3.33025 15.2036 3.17428 15.8328 3.26604 16.4508C3.3578 17.0688 3.68988 17.6256 4.19003 18L6.26004 19.57C6.65199 19.855 7.12547 20.0058 7.61003 20C7.73972 20.0127 7.87035 20.0127 8.00003 20C8.30014 19.9419 8.58526 19.8233 8.838 19.6514C9.09073 19.4794 9.30579 19.2578 9.47004 19L9.70004 18.67C9.86138 18.4386 10.0749 18.2483 10.3233 18.1145C10.5717 17.9808 10.848 17.9073 11.13 17.9C11.4256 17.8927 11.7182 17.9604 11.9805 18.0968C12.2428 18.2332 12.4663 18.4339 12.63 18.68L12.75 18.85C12.9205 19.1037 13.1412 19.3199 13.3984 19.4852C13.6555 19.6504 13.9438 19.7613 14.2455 19.8109C14.5471 19.8606 14.8558 19.848 15.1523 19.7739C15.4489 19.6997 15.7272 19.5657 15.97 19.38L18 17.86C18.48 17.4872 18.7992 16.945 18.8922 16.3444C18.9851 15.7438 18.8448 15.1304 18.5 14.63L18.24 14.25C18.0837 14.0084 17.9813 13.736 17.9399 13.4512C17.8985 13.1664 17.919 12.8761 18 12.6C18.0826 12.3044 18.236 12.0334 18.4468 11.8104C18.6576 11.5874 18.9196 11.4191 19.21 11.32L19.41 11.25C19.9887 11.0492 20.4667 10.6312 20.7429 10.0845C21.0191 9.53769 21.0718 8.90496 20.89 8.32ZM11 13.5C10.3078 13.5 9.63111 13.2947 9.05554 12.9101C8.47997 12.5256 8.03136 11.9789 7.76646 11.3394C7.50155 10.6999 7.43224 9.99612 7.56729 9.31718C7.70233 8.63825 8.03568 8.01461 8.52516 7.52513C9.01464 7.03564 9.63829 6.7023 10.3172 6.56725C10.9962 6.4322 11.6999 6.50151 12.3394 6.76642C12.979 7.03133 13.5256 7.47993 13.9102 8.0555C14.2948 8.63108 14.5 9.30777 14.5 10C14.5 10.9283 14.1313 11.8185 13.4749 12.4749C12.8185 13.1313 11.9283 13.5 11 13.5Z"
            fill={props.color}
          />
        </svg>
      );
    case "nav-profile-icon":
      return (
        <svg
          width="31"
          height="31"
          viewBox="0 0 31 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse
            cx="15.2159"
            cy="15.5"
            rx="15.2159"
            ry="15.5"
            fill="#0361F0"
            fillOpacity="0.1"
          />
          <path
            d="M15.2325 1.89435C11.0763 1.89435 7.67883 5.29185 7.67883 9.44806C7.67883 13.6043 11.0763 17.0018 15.2325 17.0018C19.3888 17.0018 22.7863 13.6043 22.7863 9.44806C22.7863 5.29185 19.3888 1.89435 15.2325 1.89435Z"
            fill="#0371AC"
          />
          <path
            d="M28.1948 23.0379C27.9969 22.5431 27.733 22.0813 27.4361 21.6525C25.9188 19.4095 23.5769 17.9251 20.938 17.5623C20.6082 17.5293 20.2453 17.5952 19.9814 17.7932C18.596 18.8157 16.9468 19.3435 15.2315 19.3435C13.5162 19.3435 11.8669 18.8157 10.4815 17.7932C10.2176 17.5952 9.85478 17.4963 9.52496 17.5623C6.88611 17.9251 4.51117 19.4095 3.02683 21.6525C2.72996 22.0813 2.46605 22.5761 2.26818 23.0379C2.16924 23.2359 2.2022 23.4667 2.30114 23.6647C2.56505 24.1265 2.89487 24.5883 3.19174 24.9841C3.65352 25.6109 4.14832 26.1716 4.7091 26.6993C5.17088 27.1611 5.69864 27.5899 6.22646 28.0188C8.83229 29.9649 11.9659 30.9874 15.1985 30.9874C18.4311 30.9874 21.5648 29.9649 24.1706 28.0188C24.6984 27.623 25.2261 27.1611 25.688 26.6993C26.2157 26.1716 26.7435 25.6108 27.2053 24.9841C27.5351 24.5553 27.8321 24.1265 28.0959 23.6647C28.2608 23.4667 28.2937 23.2358 28.1948 23.0379Z"
            fill="#0371AC"
          />
        </svg>
      );
    case "back":
      return (
        <svg
          width="7"
          height="11"
          viewBox="0 0 7 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.29957 10.0376L2.30036 10.0368L6.37901 6.12102L6.17141 5.90445L6.37917 6.12086L6.37907 6.12097C6.73225 5.78233 6.73158 5.21802 6.37946 4.87907L6.37915 4.87877L2.30038 0.963755C1.93414 0.612082 1.35586 0.612082 0.989619 0.963755L0.989566 0.963805C0.60195 1.33618 0.602232 1.95601 0.989374 2.32859L0.989642 2.32885L4.29318 5.50028L0.989642 8.67172L0.989566 8.67179C0.60195 9.04417 0.602232 9.66399 0.989374 10.0366L0.989372 10.0366L0.990428 10.0376C1.17317 10.2117 1.40897 10.3 1.64477 10.3C1.88091 10.3 2.11676 10.2118 2.29957 10.0376L2.29957 10.0376Z"
            fill="#0371AC"
            stroke="#0371AC"
            strokeWidth="0.6"
          />
        </svg>
      );
    case "profile":
      return (
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.60518 9.78131C9.82884 9.78131 11.6316 7.59171 11.6316 4.89069C11.6316 2.1896 11.0398 0 7.60518 0C4.17061 0 3.57861 2.1896 3.57861 4.89069C3.57861 7.59171 5.38141 9.78131 7.60518 9.78131Z"
            fill="#0B3275"
          />
          <path
            d="M15.2015 17.0512C15.127 12.3459 14.5125 11.0052 9.81 10.1565C9.81 10.1565 9.14806 11 7.6052 11C6.06234 11 5.40029 10.1565 5.40029 10.1565C0.749142 10.9959 0.0972571 12.3168 0.0115428 16.8983C0.00451427 17.2724 0.00125714 17.2921 0 17.2487C0.000285714 17.33 0.000628444 17.4806 0.000628444 17.743C0.000628444 17.743 1.12017 19.9999 7.6052 19.9999C14.0901 19.9999 15.2098 17.743 15.2098 17.743C15.2098 17.5744 15.2099 17.4571 15.2101 17.3774C15.2088 17.4042 15.2063 17.3522 15.2015 17.0512Z"
            fill="#0B3275"
          />
        </svg>
      );

    case "oval":
      return (
        <svg
          width="27"
          height="29"
          viewBox="0 0 27 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5 29C20.9558 29 27 22.5081 27 14.5C27 6.49187 20.9558 0 13.5 0C6.04416 0 0 6.49187 0 14.5C0 22.5081 6.04416 29 13.5 29Z"
            fill="#464DF2"
          />
        </svg>
      );
    case "breadcrumb-icon":
      return (
        <svg
          width="6"
          height="10"
          viewBox="0 0 6 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5">
            <path
              d="M0.213943 1.18939C-0.0683039 0.93083 -0.0683039 0.482652 0.196303 0.206851C0.337426 0.0689502 0.53147 4.78074e-07 0.707874 4.62652e-07C0.884278 4.47231e-07 1.06068 0.0689501 1.20181 0.189613L5.78831 4.49901C5.92944 4.63691 6 4.80928 6 4.9989C6 5.18851 5.92944 5.36089 5.78831 5.49879L1.20181 9.80818C0.91956 10.0667 0.47855 10.0667 0.196303 9.79094C-0.0683032 9.51514 -0.0683032 9.0842 0.213943 8.8084L4.27124 4.9989L0.213943 1.18939Z"
              fill="#828282"
            />
            <path
              d="M0.213943 1.18939C-0.0683039 0.93083 -0.0683039 0.482652 0.196303 0.206851C0.337426 0.0689502 0.53147 4.78074e-07 0.707874 4.62652e-07C0.884278 4.47231e-07 1.06068 0.0689501 1.20181 0.189613L5.78831 4.49901C5.92944 4.63691 6 4.80928 6 4.9989C6 5.18851 5.92944 5.36089 5.78831 5.49879L1.20181 9.80818C0.91956 10.0667 0.47855 10.0667 0.196303 9.79094C-0.0683032 9.51514 -0.0683032 9.0842 0.213943 8.8084L4.27124 4.9989L0.213943 1.18939Z"
              stroke="#828282"
            />
          </g>
        </svg>
      );
    case "charge-type":
      return (
        // <svg viewBox="0 0 21 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        //   <path
        //     d="M19.9831 2.67113L17.925 15.6061C17.8081 16.3389 17.1135 16.8433 16.3807 16.7266L9.40336 15.6165C8.66995 15.4996 8.16592 14.805 8.28265 14.072L10.3406 1.1373C10.4573 0.40431 11.1519 -0.0999267 11.8849 0.0167966L14.3796 0.413485C14.3781 0.435678 14.3762 0.457657 14.3762 0.480062C14.3762 1.04874 14.8371 1.50966 15.4055 1.50966C15.8865 1.50966 16.2881 1.18019 16.4023 0.735275L18.8618 1.12663C19.5958 1.24335 20.1001 1.93836 19.9831 2.67113ZM9.29411 16.303C8.75615 16.2177 8.28307 15.9264 7.96171 15.4832C7.64035 15.0406 7.51061 14.5001 7.59596 13.9624L9.64428 1.08779L5.15864 1.59288C4.42075 1.67589 3.88578 2.347 3.96858 3.08468L4.18325 4.99023C4.51955 4.99834 4.78948 5.27297 4.78948 5.61077C4.78948 5.9014 4.59018 6.14424 4.32088 6.21252L5.43391 16.1001C5.51714 16.8375 6.18781 17.3729 6.92592 17.2899L11.9446 16.7247L9.29411 16.303ZM4.74275 16.1775L3.56207 5.68759L3.62396 5.67201L3.56015 5.6703L3.32692 3.60001L0.943373 4.35135C0.235777 4.57455 -0.161125 5.33635 0.0622928 6.04373L3.58597 17.208C3.80939 17.9158 4.57054 18.3121 5.27921 18.0891L6.02948 17.8524C5.3413 17.5838 4.83024 16.9521 4.74275 16.1775Z"
        //     fill={props.color}
        //   />
        // </svg>
        <i className="pi pi-credit-card" style={{ color: props.color }} />
      );
    case "settlement":
      return (
        // <svg
        // 	viewBox="0 0 21 23"
        // 	fill="none"
        // 	xmlns="http://www.w3.org/2000/svg"
        // >
        // 	<path
        // 		d="M20.6483 11.9982C20.4052 11.8475 20.1287 11.7589 19.8432 11.7402C19.5578 11.7215 19.2721 11.7733 19.0113 11.891L14.9062 13.7514C15.0239 13.9491 15.1009 14.1683 15.1327 14.3962C15.176 14.6923 15.1405 14.9946 15.0299 15.2728C14.9193 15.5509 14.7375 15.795 14.5027 15.9806C14.1975 16.2239 13.819 16.3566 13.4287 16.3571C13.336 16.3571 13.2434 16.3497 13.1518 16.3347L7.37867 15.3939C7.32861 15.3858 7.28064 15.368 7.2375 15.3413C7.19435 15.3147 7.15688 15.2799 7.12722 15.2387C7.09757 15.1976 7.07631 15.1511 7.06467 15.1017C7.05304 15.0524 7.05124 15.0012 7.0594 14.9512C7.06756 14.9012 7.0855 14.8532 7.1122 14.8101C7.13891 14.7671 7.17385 14.7297 7.21503 14.7001C7.2562 14.6705 7.30281 14.6494 7.35217 14.6378C7.40154 14.6263 7.45269 14.6246 7.50271 14.6328L13.2269 15.5657C13.5177 15.6022 13.8115 15.5271 14.049 15.3555C14.1717 15.2497 14.2653 15.1142 14.3209 14.9621C14.3765 14.8099 14.3923 14.646 14.3667 14.486C14.3411 14.326 14.275 14.1752 14.1748 14.048C14.0745 13.9207 13.9433 13.8212 13.7937 13.759L9.11753 11.8119C8.99774 11.762 8.86926 11.7363 8.7395 11.7363H4.11584C3.89949 11.7363 3.68917 11.8077 3.51747 11.9393L2.53078 12.6957V12.5353C2.53078 12.3856 2.47133 12.2421 2.36551 12.1363C2.2597 12.0304 2.11617 11.971 1.96652 11.971H0.56425C0.49015 11.971 0.416775 11.9856 0.348316 12.0139C0.279858 12.0423 0.217655 12.0839 0.165259 12.1363C0.112864 12.1887 0.0713019 12.2509 0.0429466 12.3193C0.0145914 12.3878 -1.83745e-06 12.4612 1.0856e-09 12.5353V18.0773C-4.59531e-06 18.1514 0.0145865 18.2248 0.0429404 18.2933C0.0712943 18.3617 0.112856 18.4239 0.165251 18.4763C0.217647 18.5287 0.279851 18.5703 0.348311 18.5987C0.416771 18.627 0.490148 18.6416 0.56425 18.6416H1.96652C2.11618 18.6416 2.2597 18.5822 2.36552 18.4763C2.47133 18.3705 2.53078 18.227 2.53077 18.0773V17.7614L9.0409 19.2394C9.46843 19.3365 9.91124 19.3455 10.3424 19.2659C10.7735 19.1863 11.1839 19.0198 11.5486 18.7765L20.6521 13.2423C20.7587 13.1771 20.8467 13.0855 20.9076 12.9763C20.9686 12.8672 21.0004 12.7442 21 12.6192C20.9996 12.4942 20.9671 12.3714 20.9055 12.2627C20.8439 12.1539 20.7553 12.0628 20.6483 11.9982Z"
        // 		fill={props.color}
        // 	/>
        // 	<path
        // 		d="M3.68108 5.59961H9.29138C9.45034 5.59961 9.60279 5.66276 9.71519 5.77516C9.82759 5.88756 9.89074 6.04001 9.89074 6.19896V8.71797C9.89074 8.87692 9.82759 9.02937 9.7152 9.14177C9.6028 9.25417 9.45035 9.31731 9.2914 9.31731H3.68108C3.52212 9.31731 3.36967 9.25416 3.25727 9.14176C3.14487 9.02936 3.08173 8.87692 3.08173 8.71796V6.19896C3.08173 6.04001 3.14487 5.88756 3.25727 5.77516C3.36967 5.66276 3.52212 5.59961 3.68108 5.59961Z"
        // 		fill={props.color}
        // 	/>
        // 	<path
        // 		d="M14.2394 5.59961H19.8497C20.0086 5.59961 20.1611 5.66276 20.2735 5.77516C20.3859 5.88756 20.449 6.04001 20.449 6.19896V8.71795C20.449 8.79666 20.4335 8.8746 20.4034 8.94732C20.3733 9.02004 20.3291 9.08611 20.2735 9.14176C20.2178 9.19742 20.1518 9.24157 20.079 9.27169C20.0063 9.30181 19.9284 9.31731 19.8497 9.31731H14.2394C14.0804 9.31731 13.928 9.25417 13.8156 9.14177C13.7032 9.02937 13.64 8.87692 13.64 8.71797V6.19896C13.64 6.04001 13.7032 5.88756 13.8156 5.77516C13.928 5.66276 14.0804 5.59961 14.2394 5.59961Z"
        // 		fill={props.color}
        // 	/>
        // 	<path
        // 		d="M8.96019 0H14.5705C14.7295 0 14.8819 0.0631462 14.9943 0.175547C15.1067 0.287948 15.1699 0.440396 15.1699 0.599355V3.11836C15.1699 3.27732 15.1067 3.42976 14.9943 3.54216C14.8819 3.65456 14.7295 3.7177 14.5705 3.7177H8.96019C8.80124 3.7177 8.64879 3.65456 8.53639 3.54215C8.42399 3.42975 8.36084 3.27731 8.36084 3.11835V0.599355C8.36084 0.520647 8.37634 0.442709 8.40646 0.369992C8.43658 0.297275 8.48073 0.231202 8.53639 0.175547C8.59204 0.119892 8.65811 0.0757437 8.73083 0.0456233C8.80355 0.0155029 8.88149 0 8.96019 0Z"
        // 		fill={props.color}
        // 	/>
        // </svg>
        <i className="pi pi-globe" style={{ color: props.color }} />
      );
    case "success-message":
      return (
        <svg
          width="116"
          height="93"
          viewBox="0 0 116 93"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="56.6094"
            cy="46.5"
            r="43.8679"
            fill="#0371AC"
            stroke="#0371AC"
            strokeWidth="5.26415"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.6364 54.2454L37.2242 42.1751L31.1631 48.2362L46.099 63.1721C46.1971 63.2945 46.303 63.4128 46.4165 63.5264C46.53 63.6399 46.6483 63.7457 46.7708 63.8438L47.326 64.399L47.4354 64.2815C49.0556 65.1432 51.1125 64.8915 52.4776 63.5264L82.0483 33.9556L79.2814 31.1887C77.4621 29.3694 74.5124 29.3694 72.6931 31.1887L49.6364 54.2454Z"
            fill="white"
          />
          <circle cx="5.05435" cy="21.2301" r="5.05435" fill="#FBB416" />
          <circle cx="109.174" cy="68.7371" r="6.06522" fill="#FBB416" />
          <circle cx="17.184" cy="9.09511" r="3.03261" fill="#FBB416" />
          <circle cx="110.185" cy="51.556" r="3.03261" fill="#FBB416" />
          <circle cx="98.0541" cy="83.8998" r="3.03261" fill="#FBB416" />
        </svg>
      );
    case "warning":
      return (
        <img
          alt="warning"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACY0lEQVR4nO1ZTU8UQRCdoAmcFG/AxcSAVWtCOABy5GgiAcVEfgrCeTnD4m/AyyIk/gIORJxqlhCWmyf0YNYQPbpyoUw1C2T5CD3TNR8bp5JKNtnZ7feqqnteVwVBYYUV5m3MQRfvDj1nwgUm/MiEdTbwmwlOrNvPWGfCdfuMPMtBV/bAa9jPBpeY4Dsb5EhO8M3+tob96QPfHn7EBlfZYDMy8OvetP+1P9KbDniDb9jgTwXgVxwa8t/JAa8G91pRVwaOV0oLK7KWLvitxz1sYDNx8OYiG5uypl7k5fRIDTyeZ+ITb03e9yeQRtmY20jAisaGzQa8sVk4ZcLZeOBrTx4ywY+4i0+8eNXmHvuhIcd2nOi/94meHgEUX40Gnp71scE/OSLQ5D0YiBL9Jd/6VSbAgsldmJ3plHwRIDhyEoBWKfpHK4kMMBOMuZTPYm4JhKX5uwmIns8rAYNVBwJwmFsChHWHEoJfOSZw7JKBkxwT+PsfEDCdX0KHnb2JSecYTcirqb3IEvHQ5UWmJCUScXKREkpiLgHwR87dPA05/XltlKffvrS+szamQaLsBF7rQiPAz0+gmbmpdC80Gt0IVQKElSCqcTj4wOdSL2UjwMW/fBj1IACN2H1T21aR1oZ//caN/CmHpdexwF+QkF5lZgRg2Qt85q3FqlKTl78Odqfa3CXYkDVVwLdnAlYS3RMkrURYVm+vtxEhnG0NI5QJQCN2HzQyif2RXtURE2EltRHTDUO+ciztJNrGYDmTId+NAtA8HWfCd60T68De7C7HrHLLO7DfhaV5UZW5GLMWVljQ+fYPzbicDniMwzoAAAAASUVORK5CYII="
        ></img>
      );
    case "warning-status":
      return (
        <img
          alt="warning-status"
          width="15"
          height="15"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAJiElEQVR4nO1YWWxcZxUegSqoKh6QaJtuSZraTuLEiWOPY4/3JV5nyXi3Y8eOs1VIRaIP7QuoCCFV8AClUinwAu0TieNtxh57Zu7su1MEPFBeEJUooFbN2HP3e2fS9kPnv2O7SKRqS5q6wkf6dP7l/Oec7/znv9KMybQne7Ine/LfRORsgwLX85YQsL4l+vsGTF8mkdeH9/FcjyiGzkKKDEIMOUVaM31ZhA/YXGLIATk6CCU2Ajk2QiRcpi+DKH57Hc9Zb4uRAUjxUciJcSjxMUix4ffV+HCjabcLH7D9UYw4IcdHoCQnoKbOQ0lMQkmMQ4oO/MG0m0WODc0IITvk2HAx+Smo6QtQU9NQEhPGenToadNuFKD6PiFo/ZcUHYCSHIeWPg89cwFaZgZa5gLU9BSUxBiUqPMdhFu+btptIsecL4khO5T4CNTkJEtaX78IPXOJaS09DTV5DnJsCHLI+ZJpN4niH3tUDNpkJTYINXEOenqKJZ1fv4z8zcvQ1y8hTyToPcRHIYYdqpocOGDaLSKFHMti2MGqr6cmWetQ4gaBKyi8cQX59UuMmJochxwdgBi0r5h2g4iBs01CsO8D+uaz6qemkM9cQuHmFdx+4yoKhJtFApkZqMkJKLFhSCH7B1rQ3v5F52+SQrY/yZGzUIvVz6dnUFi/jMK6QeD2G08bJOg2MjPQU+ehJkahRJwQgn1vfqHJ8wHrM2LIBqP3x9iXJ5+h3r+EHzw7gN7eXgYas3bKXGQ3pNFjjg5CClohBXqf+UKSR2r4fiHY+64UNqqvJSeQp97PXMTtm5cxPtSH7u5uhnNDfSiwN0HvYJrZ0hkp7IDAdd16x9f5wD0nIAd7fyGFrFCiA9ASo9CTkwaB9RmW7JXzVnR2djJcnbKisH4JBfoypaehE4HECOSIE1KwF0Kg89V7mjy/Yj0kBrpVOWLfaR/q//UigfWL+O5lKzo6OhievWJF4SYRmEE+M83eCp1RqI1CNvD+dl33nym9ZwRErstHlVOiTqjxIehJ+vbTDUyzWyjcvIjvPWNFW1sbw/e/Y2PJGwSmkE9NQkuMQY0PQok4IHGdELxt3D1Jng/0dopc54dy2AaV2oe+Pskx5IlA+jwKmWncXr+AHz9nQ0tLC8NPnicC0yikp1Cgh56cYGfUGBE4CznYA97b+qHAddk+1+QB01cEruMvUqCHVU6NDkJLDENPjhu3kJpAPnUe+fQUXnnBjqamJoZXX7CjQJWn5NOT0FPj0OndxIehRvohh6wQ/WcgrDb9lWJ8bgQEruM5CiQHe6FGHNBig9CTRGAU+dQ48qlzKGQmUUhP4LUX7WhoaGB4/UXH9jrZ5IlwYgRafAhazAk1YoMU6ATvbYa41vz855I8Eo5vSP7WW3KgC0rYCi16Flq8H3p8EPnkMPLJURRSYwxEZuElOywWC8PCz23GXnochfQos9WTQ+ysQcAKOdAN0dcKYbV+E/HGb951Avxa829EfxvkYLdBIOaAHuuHFh+AnqCHTCRGUGC3MQr/L+2ora1l4H5lY0kbGGH2VH09NmAUImyDEuyBxHVAXG0Av2J57a4mL3q7jgje5jwFUELdUMNW6BEH9LgTWqwf+fgA8omhbRQSQ0j/1gaz2cyQed1u3FJxXyfShFg/9KgDWsQKNdwDOXAGorcZOU9tYXO19sRdIyB4G6KSrwVyoANqqBtauA9a1AYt6kCebiLuhB7vRz5BZAz952tWVFVVMbw5a0U+QST7ocfI1ok8nYnRLdqYvy0CMkdtZAHvqYnfleRz3kansNrwoexvZQHUUBfUUC+0SB/0iBV61M6IGC1lZxUlvL3ch8rKSoZ/uK0G0e19O7QIwQY90gct3PsRAm0Q1xqQWzGD95hH/6fkMTv8VcFT+zdxrRGyrwUK1wE52Fm8hR4WmEhoEYMQIxW1FluiDxNnaxiUEBG1Fm+O2s+6ba+Ge5g/Ndhp+Pe1guLxK6eRc1X+Hb+uvu8zE5A8NT8U1+og+Roh+1ugBNqhBOkWOqGFCV3QGbqhRQg90EI90GnM1noY2Jyt0dzYY2fCXQzkj/wqXDsUfwskbwPE1Vrw7koIy5U/+mzVD1d/i18x8zsEmqFybVAD7VCD7VBDHdCCHdBCZ6ARIZqHzxhrW6C1op0eOsNAYzVIms51QGXzduZX4dog+5oh+RpAcfmVKuTcFaIUqH34UxMQlk9dFzxm5kj2NUDxN0HhiAS1Uiu0UBvUIBFqhUY62AqNxmzeCv/LFjTXHUOL5Ri4ly3Qg1tnDHutqJUAoRUqR2iG4muC4jcIiKtm8O4KbLjK5z5V8rznlJlfPnlb9Jgheesge+uZU9nXWAxARAxCDH7StN5krPsb0XT6KMrKyhiaa4+y9S3sFKMZKo3pPGm6aV8jJG89pLU6UAFz7pPILh19X1g8XP/Jq+8+8XthpRKipxqyt9Yg4bNA8tVDIfhJ060YY5mzQPFbmA1B8VnQYC5DSUkJQ2NNGVvb3ufqofrqoXJFP74dfxKzqYO8dprF55crkXOVY3Ox7JP9q5dzlV/gXcdhEKiCtGqGtFbDHBpkapmW10if3gGzMUP2kq6B96eVsFSVoL66BP6fVRrnmU0Ns5do7qO1or9tGHYUl+LzyyfBu45hY74U/ELZtz82eayWfC23ePSfgvs4xOWTED0GCXmVYIa8Wm0kSXobVZCYzSlIBM8pyJ5KSISVj8BDe1ua7KuZluiWPWbD71q1UTBPNYtL8YXlCvBL5dicP4zs3MF3307V3X/n6i+UvpJbPILcUjkEdwWE5ROMiLRyEsLKCYgrJw0snzD23LRPqAAj7SLixyC6j0FwH2Njtu7eWjtuzJcrDB/unRiGb0p4a0wxKiC4jrMWyi2WYWPuEDZvHLzzz8+NuUPvkSG/dAS86yhEdzmDUNRGQjSnvSMQXEfALx0Gv1QG3lW2o12l/4HcUikEGm/vk+1hdl5kKGcQXDvxGFzlxVwOI7dYis35J5G98fh7dySQnXvyVm7hKfCLJexAbqGot8YLTzHw84eQY3gSm3MHkZs/gE3C3AFszO3fxubcEx+ZH8DGlt08jQ+yhMgP+eMXyXcJeMJi6TaMuCXYnD+EjbmDH0/g1uxjV7Oz+7MbN4rJ3KAk9mPjxhPYmH0cG7OPMWSvP4rstUeQvbYP2ev7kL32MLLXHsIthgcN/O6hIh5Etqhpn+yYPTv3CLLXCY8afikGxSLiNyjuVh6k99N+9tbsvt359/ye7Mme/J/KvwGZaxf4l+/MkQAAAABJRU5ErkJggg=="
        ></img>
      );
    case "no-item":
      return (
        <svg
          width="250"
          height="200"
          viewBox="0 0 250 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M93 135H176C179.866 135 183 131.866 183 128C183 124.134 179.866 121 176 121C176 121 170 117.866 170 114C170 110.134 173.952 107 178.826 107H189C192.866 107 196 103.866 196 100C196 96.134 192.866 93 189 93H167C170.866 93 174 89.866 174 86C174 82.134 170.866 79 167 79H207C210.866 79 214 75.866 214 72C214 68.134 210.866 65 207 65H109C105.134 65 102 68.134 102 72C102 75.866 105.134 79 109 79H69C65.134 79 62 82.134 62 86C62 89.866 65.134 93 69 93H94C97.866 93 101 96.134 101 100C101 103.866 97.866 107 94 107H54C50.134 107 47 110.134 47 114C47 117.866 50.134 121 54 121H93C89.134 121 86 124.134 86 128C86 131.866 89.134 135 93 135ZM200 100C200 103.866 203.134 107 207 107C210.866 107 214 103.866 214 100C214 96.134 210.866 93 207 93C203.134 93 200 96.134 200 100Z"
            fill="#F3F7FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M153.672 64.0007L162.974 131.843L163.809 138.65C164.079 140.842 162.519 142.838 160.327 143.107L101.767 150.298C99.5739 150.567 97.5781 149.008 97.3089 146.815L88.2931 73.3874C88.1585 72.2911 88.9381 71.2932 90.0345 71.1586C90.0414 71.1578 90.0483 71.1569 90.0553 71.1562L94.9136 70.6112M98.8421 70.1705L103.429 69.656L98.8421 70.1705Z"
            fill="white"
          />
          <path
            d="M154.91 63.8309C154.817 63.1469 154.186 62.6685 153.502 62.7623C152.818 62.856 152.34 63.4865 152.433 64.1705L154.91 63.8309ZM162.974 131.843L164.214 131.691L164.213 131.682L164.212 131.674L162.974 131.843ZM163.809 138.65L165.05 138.497L163.809 138.65ZM160.327 143.107L160.479 144.348L160.327 143.107ZM101.767 150.298L101.919 151.538L101.767 150.298ZM97.3089 146.815L98.5496 146.663L97.3089 146.815ZM90.0553 71.1562L90.1946 72.3984L90.0553 71.1562ZM95.053 71.8534C95.739 71.7764 96.2328 71.1579 96.1558 70.4718C96.0789 69.7858 95.4603 69.292 94.7743 69.369L95.053 71.8534ZM98.7028 68.9283C98.0168 69.0053 97.523 69.6238 97.5999 70.3098C97.6769 70.9959 98.2954 71.4897 98.9815 71.4127L98.7028 68.9283ZM103.569 70.8982C104.255 70.8212 104.748 70.2027 104.671 69.5166C104.594 68.8306 103.976 68.3368 103.29 68.4137L103.569 70.8982ZM152.433 64.1705L161.735 132.013L164.212 131.674L154.91 63.8309L152.433 64.1705ZM161.733 131.996L162.569 138.802L165.05 138.497L164.214 131.691L161.733 131.996ZM162.569 138.802C162.754 140.31 161.682 141.682 160.174 141.867L160.479 144.348C163.357 143.995 165.404 141.375 165.05 138.497L162.569 138.802ZM160.174 141.867L101.614 149.057L101.919 151.538L160.479 144.348L160.174 141.867ZM101.614 149.057C100.107 149.242 98.7347 148.17 98.5496 146.663L96.0682 146.967C96.4216 149.845 99.041 151.892 101.919 151.538L101.614 149.057ZM98.5496 146.663L89.5338 73.2351L87.0524 73.5398L96.0682 146.967L98.5496 146.663ZM89.5338 73.2351C89.4833 72.824 89.7757 72.4498 90.1868 72.3993L89.8821 69.9179C88.1006 70.1367 86.8337 71.7582 87.0524 73.5398L89.5338 73.2351ZM90.1868 72.3993C90.1894 72.399 90.192 72.3987 90.1946 72.3984L89.9159 69.914C89.9046 69.9152 89.8934 69.9165 89.8821 69.9179L90.1868 72.3993ZM90.1946 72.3984L95.053 71.8534L94.7743 69.369L89.9159 69.914L90.1946 72.3984ZM98.9815 71.4127L103.569 70.8982L103.29 68.4137L98.7028 68.9283L98.9815 71.4127Z"
            fill="#0371AC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M151.14 68.2686L159.56 129.752L160.317 135.921C160.561 137.908 159.167 139.714 157.203 139.955L104.761 146.394C102.798 146.635 101.008 145.22 100.764 143.233L92.6141 76.8562C92.4795 75.7599 93.2592 74.762 94.3555 74.6274L100.843 73.8308"
            fill="#E8F0FE"
          />
          <path
            d="M107.922 54C107.922 52.4812 109.153 51.25 110.672 51.25H156.229C156.958 51.25 157.657 51.5395 158.173 52.0549L171.616 65.4898C172.132 66.0056 172.422 66.7053 172.422 67.4349V130C172.422 131.519 171.191 132.75 169.672 132.75H110.672C109.153 132.75 107.922 131.519 107.922 130V54Z"
            fill="white"
            stroke="#0371AC"
            strokeWidth="2.5"
          />
          <path
            d="M156.672 52.4023V63.9995C156.672 65.6564 158.015 66.9995 159.672 66.9995H167.605"
            stroke="#0371AC"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M118.672 64.5C117.291 64.5 116.172 65.6193 116.172 67H118.672V64.5ZM144.672 64.5H118.672V67H144.672V64.5ZM147.172 67C147.172 65.6193 146.053 64.5 144.672 64.5V67H147.172ZM144.672 69.5C146.053 69.5 147.172 68.3807 147.172 67H144.672V69.5ZM118.672 69.5H144.672V67H118.672V69.5ZM116.172 67C116.172 68.3807 117.291 69.5 118.672 69.5V67H116.172ZM118.672 76.5C117.291 76.5 116.172 77.6193 116.172 79H118.672V76.5ZM161.672 76.5H118.672V79H161.672V76.5ZM164.172 79C164.172 77.6193 163.053 76.5 161.672 76.5V79H164.172ZM161.672 81.5C163.053 81.5 164.172 80.3807 164.172 79H161.672V81.5ZM118.672 81.5H161.672V79H118.672V81.5ZM116.172 79C116.172 80.3807 117.291 81.5 118.672 81.5V79H116.172ZM118.672 92V89.5C117.291 89.5 116.172 90.6193 116.172 92H118.672ZM118.672 92H116.172C116.172 93.3807 117.291 94.5 118.672 94.5V92ZM161.672 92H118.672V94.5H161.672V92ZM161.672 92V94.5C163.053 94.5 164.172 93.3807 164.172 92H161.672ZM161.672 92H164.172C164.172 90.6193 163.053 89.5 161.672 89.5V92ZM118.672 92H161.672V89.5H118.672V92ZM118.672 102.5C117.291 102.5 116.172 103.619 116.172 105H118.672V102.5ZM161.672 102.5H118.672V105H161.672V102.5ZM164.172 105C164.172 103.619 163.053 102.5 161.672 102.5V105H164.172ZM161.672 107.5C163.053 107.5 164.172 106.381 164.172 105H161.672V107.5ZM118.672 107.5H161.672V105H118.672V107.5ZM116.172 105C116.172 106.381 117.291 107.5 118.672 107.5V105H116.172ZM118.672 118V115.5C117.291 115.5 116.172 116.619 116.172 118H118.672ZM118.672 118H116.172C116.172 119.381 117.291 120.5 118.672 120.5V118ZM144.672 118H118.672V120.5H144.672V118ZM144.672 118V120.5C146.053 120.5 147.172 119.381 147.172 118H144.672ZM144.672 118H147.172C147.172 116.619 146.053 115.5 144.672 115.5V118ZM118.672 118H144.672V115.5H118.672V118Z"
            fill="#A4C3FE"
          />
        </svg>
      );
    case "error-message-icon":
      return (
        <svg
          width="112"
          height="90"
          viewBox="0 0 112 90"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="54.5388"
            cy="44.7986"
            r="42.2628"
            fill="#F4803C"
            stroke="#FAB417"
            strokeWidth="5.07154"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M39.6644 28.3151C41.4179 26.5616 44.2608 26.5616 46.0142 28.3151L55.1235 37.4244L64.2328 28.3151C65.9862 26.5616 68.8291 26.5616 70.5826 28.3151L73.247 30.9795L60.9628 43.2637L71.0728 53.3737C72.8263 55.1271 72.8263 57.9701 71.0728 59.7235L68.4084 62.3879L55.1235 49.103L41.8386 62.3879L39.1742 59.7235C37.4207 57.9701 37.4207 55.1271 39.1742 53.3737L49.2842 43.2637L37 30.9795L39.6644 28.3151Z"
            fill="#063A4F"
          />
          <circle cx="4.86941" cy="20.4524" r="4.86941" fill="#FAB417" />
          <circle cx="105.179" cy="66.2242" r="5.8433" fill="#FAB417" />
          <circle cx="16.5545" cy="8.76637" r="2.92165" fill="#F4803C" />
          <circle cx="106.154" cy="49.6687" r="2.92165" fill="#F4803C" />
          <circle cx="94.4666" cy="80.8318" r="2.92165" fill="#F4803C" />
        </svg>
      );
    case "pagination-strong-left":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="20"
            height="20"
            rx="1"
            transform="matrix(-1 0 0 1 20 0)"
            fill="#EFF5FC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.2526 6.32712L12.8 5.87451L8.27384 10.4006L8.72646 10.8532L8.72694 10.8527L12.8013 14.927L13.254 14.4743L9.17965 10.4L13.2526 6.32712Z"
            fill={props?.color}
          />
          <path
            d="M12.8 5.87451L13.0842 5.593L12.8 5.30883L12.5158 5.593L12.8 5.87451ZM13.2526 6.32712L13.5368 6.60864L13.8183 6.32712L13.5368 6.04561L13.2526 6.32712ZM8.27384 10.4006L7.98967 10.1191L7.70816 10.4006L7.98967 10.6821L8.27384 10.4006ZM8.72646 10.8532L8.44229 11.1347L8.72649 11.4189L9.01066 11.1347L8.72646 10.8532ZM8.72694 10.8527L9.01111 10.5712L8.72692 10.287L8.44275 10.5713L8.72694 10.8527ZM12.8013 14.927L12.5171 15.2086L12.8013 15.4927L13.0855 15.2086L12.8013 14.927ZM13.254 14.4743L13.5382 14.7559L13.8197 14.4743L13.5382 14.1928L13.254 14.4743ZM9.17965 10.4L8.89548 10.1185L8.61396 10.4L8.89548 10.6816L9.17965 10.4ZM12.5158 6.15603L12.9684 6.60864L13.5368 6.04561L13.0842 5.593L12.5158 6.15603ZM8.55801 10.6821L13.0842 6.15603L12.5158 5.593L7.98967 10.1191L8.55801 10.6821ZM9.01063 10.5717L8.55801 10.1191L7.98967 10.6821L8.44229 11.1347L9.01063 10.5717ZM8.44275 10.5713L8.44226 10.5717L9.01066 11.1347L9.01114 11.1342L8.44275 10.5713ZM13.0855 14.6455L9.01111 10.5712L8.44277 11.1343L12.5171 15.2086L13.0855 14.6455ZM12.9698 14.1928L12.5171 14.6455L13.0855 15.2086L13.5382 14.7559L12.9698 14.1928ZM8.89548 10.6816L12.9698 14.7559L13.5382 14.1928L9.46382 10.1185L8.89548 10.6816ZM12.9684 6.04561L8.89548 10.1185L9.46382 10.6816L13.5368 6.60864L12.9684 6.04561Z"
            fill={props?.color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.99999 5.61304V15.3605V5.61304Z"
            fill={props?.color}
          />
          <path
            d="M5.99999 5.61304V15.3605"
            stroke={props?.color}
            strokeWidth="1.5"
          />
        </svg>
      );
    case "pagination-left":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="20"
            height="20"
            rx="1"
            transform="matrix(-1 0 0 1 20 0)"
            fill="#EFF5FC"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.4526 6.32712L12 5.87451L7.47388 10.4006L7.92649 10.8532L7.92697 10.8528L12.0013 14.927L12.454 14.4743L8.37968 10.4001L12.4526 6.32712Z"
            fill={props?.color}
          />
          <path
            d="M12 5.87451L12.2842 5.593L12 5.30883L11.7158 5.593L12 5.87451ZM12.4526 6.32712L12.7368 6.60863L13.0183 6.32712L12.7368 6.04561L12.4526 6.32712ZM7.47388 10.4006L7.1897 10.1191L6.90819 10.4006L7.1897 10.6821L7.47388 10.4006ZM7.92649 10.8532L7.64231 11.1347L7.92651 11.4189L8.21069 11.1347L7.92649 10.8532ZM7.92697 10.8528L8.21115 10.5712L7.92695 10.287L7.64277 10.5713L7.92697 10.8528ZM12.0013 14.927L11.7171 15.2086L12.0013 15.4927L12.2855 15.2086L12.0013 14.927ZM12.454 14.4743L12.7382 14.7559L13.0197 14.4743L12.7382 14.1928L12.454 14.4743ZM8.37968 10.4001L8.0955 10.1185L7.81399 10.4001L8.0955 10.6816L8.37968 10.4001ZM11.7158 6.15602L12.1684 6.60863L12.7368 6.04561L12.2842 5.593L11.7158 6.15602ZM7.75805 10.6821L12.2842 6.15602L11.7158 5.593L7.1897 10.1191L7.75805 10.6821ZM8.21067 10.5717L7.75805 10.1191L7.1897 10.6821L7.64231 11.1347L8.21067 10.5717ZM7.64277 10.5713L7.64229 10.5718L8.21069 11.1347L8.21117 11.1342L7.64277 10.5713ZM12.2855 14.6455L8.21115 10.5712L7.6428 11.1343L11.7171 15.2086L12.2855 14.6455ZM12.1698 14.1928L11.7171 14.6455L12.2855 15.2086L12.7382 14.7559L12.1698 14.1928ZM8.0955 10.6816L12.1698 14.7559L12.7382 14.1928L8.66385 10.1185L8.0955 10.6816ZM12.1684 6.04561L8.0955 10.1185L8.66385 10.6816L12.7368 6.60863L12.1684 6.04561Z"
            fill={props?.color}
          />
        </svg>
      );
    case "pagination-right":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="20" height="20" rx="1" fill="#EFF5FC" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.54737 6.32712L7.99998 5.87451L12.5262 10.4006L12.0735 10.8532L12.073 10.8527L7.99869 14.927L7.54598 14.4743L11.6203 10.4L7.54737 6.32712Z"
            fill={props?.color}
          />
          <path
            d="M7.99998 5.87451L7.71581 5.593L7.99998 5.30883L8.28416 5.593L7.99998 5.87451ZM7.54737 6.32712L7.2632 6.60864L6.98168 6.32712L7.2632 6.04561L7.54737 6.32712ZM12.5262 10.4006L12.8103 10.1191L13.0918 10.4006L12.8103 10.6821L12.5262 10.4006ZM12.0735 10.8532L12.3577 11.1348L12.0735 11.4189L11.7894 11.1347L12.0735 10.8532ZM12.073 10.8527L11.7889 10.5712L12.0731 10.2871L12.3572 10.5712L12.073 10.8527ZM7.99869 14.927L8.28286 15.2086L7.99869 15.4927L7.71451 15.2086L7.99869 14.927ZM7.54598 14.4743L7.26181 14.7559L6.98029 14.4743L7.26181 14.1928L7.54598 14.4743ZM11.6203 10.4L11.9045 10.1185L12.186 10.4L11.9045 10.6816L11.6203 10.4ZM8.28416 6.15602L7.83154 6.60864L7.2632 6.04561L7.71581 5.593L8.28416 6.15602ZM12.242 10.6821L7.71581 6.15602L8.28416 5.593L12.8103 10.1191L12.242 10.6821ZM11.7894 10.5717L12.242 10.1191L12.8103 10.6821L12.3577 11.1348L11.7894 10.5717ZM12.3572 10.5712L12.3577 10.5717L11.7894 11.1347L11.7889 11.1342L12.3572 10.5712ZM7.71451 14.6455L11.7889 10.5712L12.3572 11.1343L8.28286 15.2086L7.71451 14.6455ZM7.83015 14.1928L8.28286 14.6455L7.71451 15.2086L7.26181 14.7559L7.83015 14.1928ZM11.9045 10.6816L7.83015 14.7559L7.26181 14.1928L11.3362 10.1185L11.9045 10.6816ZM7.83154 6.04561L11.9045 10.1185L11.3362 10.6816L7.2632 6.60864L7.83154 6.04561Z"
            fill={props?.color}
          />
        </svg>
      );
    case "pagination-strong-right":
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="20" height="20" rx="1" fill="#EFF5FC" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.74737 6.32712L7.19998 5.87451L11.7261 10.4006L11.2735 10.8532L11.273 10.8528L7.19875 14.927L6.74604 14.4743L10.8203 10.4001L6.74737 6.32712Z"
            fill={props?.color}
          />
          <path
            d="M7.19998 5.87451L6.9158 5.59301L7.19998 5.30883L7.48416 5.59301L7.19998 5.87451ZM6.74737 6.32712L6.46319 6.60863L6.18168 6.32712L6.46319 6.04562L6.74737 6.32712ZM11.7261 10.4006L12.0103 10.1191L12.2918 10.4006L12.0103 10.6821L11.7261 10.4006ZM11.2735 10.8532L11.5577 11.1347L11.2734 11.419L10.9893 11.1347L11.2735 10.8532ZM11.273 10.8528L10.9888 10.5713L11.2731 10.287L11.5572 10.5713L11.273 10.8528ZM7.19875 14.927L7.48293 15.2085L7.19875 15.4927L6.91456 15.2085L7.19875 14.927ZM6.74604 14.4743L6.46186 14.7558L6.18036 14.4743L6.46186 14.1928L6.74604 14.4743ZM10.8203 10.4001L11.1045 10.1186L11.386 10.4001L11.1045 10.6816L10.8203 10.4001ZM7.48416 6.15602L7.03155 6.60863L6.46319 6.04562L6.9158 5.59301L7.48416 6.15602ZM11.4419 10.6821L6.9158 6.15602L7.48416 5.59301L12.0103 10.1191L11.4419 10.6821ZM10.9893 10.5717L11.4419 10.1191L12.0103 10.6821L11.5577 11.1347L10.9893 10.5717ZM11.5572 10.5713L11.5577 10.5718L10.9893 11.1347L10.9888 11.1342L11.5572 10.5713ZM6.91456 14.6455L10.9888 10.5713L11.5572 11.1343L7.48293 15.2085L6.91456 14.6455ZM7.03023 14.1928L7.48293 14.6455L6.91456 15.2085L6.46186 14.7558L7.03023 14.1928ZM11.1045 10.6816L7.03023 14.7558L6.46186 14.1928L10.5361 10.1186L11.1045 10.6816ZM7.03155 6.04562L11.1045 10.1186L10.5361 10.6816L6.46319 6.60863L7.03155 6.04562Z"
            fill={props?.color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 5.61304V15.3605V5.61304Z"
            fill={props?.color}
          />
          <path d="M14 5.61304V15.3605" stroke={props?.color} strokeWidth="1.5" />
        </svg>
      );
    case "transaction":
      return (
        // <svg
        // 	viewBox="0 0 21 23"
        // 	fill="none"
        // 	xmlns="http://www.w3.org/2000/svg"
        // >
        // 	<path
        // 		d="M15.1325 0.00217987C14.9962 0.0184998 14.8944 0.133701 14.8944 0.270992V3.48111H7.95935C7.81151 3.48207 7.69152 3.60207 7.69054 3.74992V7.45941C7.6915 7.60725 7.8115 7.72724 7.95935 7.72823H14.8944V10.9383C14.8973 11.0459 14.9636 11.1419 15.0644 11.1822C15.1642 11.2225 15.2784 11.1985 15.3552 11.1227L20.6391 5.79262C20.7408 5.68798 20.7408 5.52094 20.6391 5.41632L15.3552 0.0786603C15.2967 0.0201007 15.2141 -0.00773896 15.1325 0.00186042L15.1325 0.00217987ZM5.52479 6.03091C5.46432 6.03763 5.40671 6.06451 5.36351 6.10771L0.0796803 11.4377C0.0288007 11.4886 -5.27999e-08 11.5577 -5.27999e-08 11.6297C-5.27999e-08 11.7017 0.0288007 11.7709 0.0796803 11.8217L5.36351 17.1518C5.44128 17.2286 5.55743 17.2516 5.65823 17.2094C5.75903 17.1671 5.82431 17.0692 5.82431 16.9598V13.7573H12.7594C12.9072 13.7563 13.0272 13.6363 13.0282 13.4885V9.77899C13.0301 9.70699 13.0023 9.63691 12.9514 9.58411C12.9015 9.53227 12.8314 9.50347 12.7594 9.50251H5.82432V6.30001C5.82432 6.22321 5.79168 6.15025 5.73408 6.09937C5.67744 6.04753 5.6016 6.02353 5.5248 6.03121L5.52479 6.03091Z"
        // 		fill={props.color}
        // 	/>
        // </svg>
        <i className="pi pi-list" style={{ color: props.color }} />
      );
    case "upload":
      return (
        <svg
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="38"
            height="38"
            rx="12"
            fill="#221ED9"
            fillOpacity="0.15"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.1 16.3V11.35L25.05 16.3M13.8 10C12.801 10 12 10.801 12 11.8V26.2C12 27.1941 12.8059 28 13.8 28H24.6C25.5941 28 26.4 27.1941 26.4 26.2V15.4L21 10H13.8Z"
            fill="#0371AC"
          />
        </svg>
      );
    case "go-back-icon":
      return (
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="13.5"
            cy="13.5"
            r="13.5"
            transform="rotate(90 13.5 13.5)"
            fill="#464DF2"
            fillOpacity="0.1"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5174 18.8199L10.1308 13.4339C9.89128 13.1941 9.89128 12.8057 10.1308 12.5662L15.5174 7.17965C15.757 6.94012 16.1454 6.94012 16.385 7.17965L16.8188 7.61349C17.0586 7.85301 17.0586 8.24175 16.8188 8.48144L12.3 13L16.8188 17.5187C17.0586 17.7582 17.0586 18.1467 16.8188 18.3863L16.385 18.8202C16.1451 19.06 15.757 19.06 15.5174 18.8199Z"
            fill="#464DF2"
          />
        </svg>
      );
    case "merchant-user":
      return <i className="pi pi-user" style={{ color: props.color }} />;
    case "workflow":
      return <i className="pi pi-sitemap" style={{ color: props.color }} />;
    case "dispute":
      return <i className="pi pi-comments" style={{ color: props.color }} />;
    case "bulk-disputes":
      return <i className="pi pi-book" style={{ color: props.color }} />;
    case "terminals":
      return <i className="pi pi-folder-open" style={{ color: props.color }} />;
    case "close":
      return (
        <svg
          version="1.0"
          xmlns="http://www.w3.org/2000/svg"
          width="32.000000pt"
          height="32.000000pt"
          viewBox="0 0 32.000000 32.000000"
          preserveAspectRatio="xMidYMid meet"
        >
          <g
            transform="translate(0.000000,32.000000) scale(0.100000,-0.100000)"
            fill="#0371AC"
            stroke="none"
          >
            <path d="M0 160 l0 -160 160 0 160 0 0 160 0 160 -160 0 -160 0 0 -160z" />
          </g>
        </svg>
      );
    case "settings":
      return <i className="pi pi-cog" style={{ color: props.color }} />;
    case "participant-users":
      return <i className="pi pi-users" style={{ color: props.color }} />;
    case "participant-reports":
      return <i className="pi pi-file" style={{ color: props.color }} />;
    case "eye":
      return (
        <i className="pi pi-eye" style={{ color: "rgb(109, 140, 152)" }} />
      );
    case "question":
      return <i className="pi pi-question" />;
    case "reconciliation":
      return <i className="pi pi-table" style={{ color: props.color }} />;
    case "slashed-eye":
      return (
        <i
          className="pi pi-eye-slash"
          style={{ color: "rgb(109, 140, 152)" }}
        />
      );
    case "uptick":
      return (
        <svg
          data-v-254b7dbb=""
          xmlns="http://www.w3.org/2000/svg"
          width="14px"
          height="14px"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#28c76f"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-trending-up text-success"
        >
          <polyline
            data-v-254b7dbb=""
            points="23 6 13.5 15.5 8.5 10.5 1 18"
          ></polyline>
          <polyline data-v-254b7dbb="" points="17 6 23 6 23 12"></polyline>
        </svg>
      );
    case "downtick":
      return (
        <svg
          data-v-254b7dbb=""
          xmlns="http://www.w3.org/2000/svg"
          width="14px"
          height="14px"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ea5455"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="feather feather-trending-down text-danger"
        >
          <polyline
            data-v-254b7dbb=""
            points="23 18 13.5 8.5 8.5 13.5 1 6"
          ></polyline>
          <polyline data-v-254b7dbb="" points="17 18 23 18 23 12"></polyline>
        </svg>
      );
    case "tooltip":
      return (
        <svg
          aria-hidden="true"
          className="tooltip-svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
        >
          <path d="M7 1a6 6 0 1 1 0 12A6 6 0 0 1 7 1Zm1 10V6H6v5h2Zm0-6V3H6v2h2Z"></path>
        </svg>
      );
    case "not-found":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          data-name="Layer 1"
          viewBox="0 0 650 512"
        >
          <circle cx="328.735" cy="256.85" r="157.404" fill="#dbe8ec" />
          <path
            fill="#dbe8ec"
            d="M534.38765,226.17651V210.34927a11.37979,11.37979,0,0,0-11.37979-11.37979H482.84108a11.37979,11.37979,0,0,1-11.37979-11.37979V171.76246a11.37979,11.37979,0,0,1,11.37979-11.37979h1.26822a11.37978,11.37978,0,0,0,11.37979-11.37979V133.17565a11.37978,11.37978,0,0,0-11.37979-11.37979H192.27543a11.37979,11.37979,0,0,0-11.37979,11.37979v15.82723a11.37979,11.37979,0,0,0,11.37979,11.37979h0a11.37978,11.37978,0,0,1,11.37979,11.37979v15.82723a11.37978,11.37978,0,0,1-11.37979,11.37979H148.26879A11.37979,11.37979,0,0,0,136.889,210.34927v15.82724a11.37979,11.37979,0,0,0,11.37978,11.37979h17.26754a11.37978,11.37978,0,0,1,11.37979,11.37979V264.7634a11.37978,11.37978,0,0,1-11.37979,11.37978h-.04173A11.3798,11.3798,0,0,0,154.11481,287.523v15.82716a11.37979,11.37979,0,0,0,11.37979,11.37979h2.49825a11.37979,11.37979,0,0,1,11.37979,11.37979V341.937a11.37978,11.37978,0,0,1-11.37979,11.37979H126.99214a11.37979,11.37979,0,0,0-11.37979,11.37979v15.82724a11.37978,11.37978,0,0,0,11.37979,11.37978H490.21879a11.37978,11.37978,0,0,0,11.37979-11.37978V364.6966a11.37979,11.37979,0,0,0-11.37979-11.37979H480.352A11.37979,11.37979,0,0,1,468.97217,341.937V326.10971A11.3798,11.3798,0,0,1,480.352,314.72992h23.265a11.37978,11.37978,0,0,0,11.37978-11.37979V287.523A11.37979,11.37979,0,0,0,503.617,276.14318h-7.05753a11.37979,11.37979,0,0,1-11.37979-11.37978V248.93609a11.37979,11.37979,0,0,1,11.37979-11.37979h26.44839A11.37979,11.37979,0,0,0,534.38765,226.17651Z"
          />
          <line
            x1="393.152"
            x2="423.473"
            y1="117.511"
            y2="117.511"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="393.152"
            x2="423.473"
            y1="126.25"
            y2="126.25"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="393.152"
            x2="423.473"
            y1="134.989"
            y2="134.989"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="414.157"
            x2="444.478"
            y1="360.745"
            y2="360.745"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="414.157"
            x2="444.478"
            y1="369.484"
            y2="369.484"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="414.157"
            x2="444.478"
            y1="378.223"
            y2="378.223"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="162.528"
            x2="192.849"
            y1="216.199"
            y2="216.199"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="162.528"
            x2="192.849"
            y1="224.938"
            y2="224.938"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <line
            x1="162.528"
            x2="192.849"
            y1="233.677"
            y2="233.677"
            fill="none"
            stroke="#b9d4db"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />
          <path
            fill="#e06714"
            d="M495.29558,331.85966,377.81538,343.6786l-117.4802-11.81894a2,2,0,0,1-1.7998-1.99l-2.76845-8.09676,2.76845-132.65435,119.28,12,119.28-12L499.72693,322.853l-2.63155,7.01676A2,2,0,0,1,495.29558,331.85966Z"
          />
          <path
            fill="#ee781d"
            d="M499.72693,322.853,377.81538,334.618,255.76693,321.773l2.76845-139.50369a2,2,0,0,1,2.2002-1.99L377.81538,192.058l117.0798-11.77865a2,2,0,0,1,2.2002,1.99Z"
          />
          <polygon
            fill="#e06714"
            points="376.855 325.258 494.087 313.853 489.198 180.852 385.606 191.274 376.855 325.258"
          />
          <polygon
            fill="#e06714"
            points="376.855 176.458 479.335 164.938 484.082 314.826 376.855 325.258 376.855 176.458"
          />
          <polygon
            fill="#e06714"
            points="382.615 175.498 274.855 173.578 280.615 319.498 376.855 325.258 382.615 175.498"
          />
          <polygon
            fill="#f9ae2b"
            points="377.815 168.538 480.295 157.018 487.495 307.258 377.815 317.338 377.815 168.538"
          />
          <polygon
            fill="#e59413"
            points="377.815 312.364 377.815 317.338 487.495 307.258 487.258 302.306 377.815 312.364"
          />
          <polygon
            fill="#f9ae2b"
            points="377.815 168.538 270.055 166.618 275.815 312.538 377.815 317.338 377.815 168.538"
          />
          <polygon
            fill="#e59413"
            points="275.815 312.538 377.815 317.338 377.815 312.214 275.815 307.413 275.815 312.538"
          />
          <path
            fill="#e59413"
            d="M282.60066 263.8533a54.05616 54.05616 0 0040.4815 50.90906l44.89325 2.11255V174.778s-33.92065 2.40845-69.09259-7.64648l-18.81964-.33521zM435.05726 312.0773a81.2126 81.2126 0 0033.94421-70.11841l-4.11206-83.20911-24.85388 2.79383c-22.7196 11.50281-50.50238 18.71216-50.50238 18.71216V316.26114z"
          />
          <path
            fill="#f9ae2b"
            d="M377.81538,168.538s57.36-14.88,74.64-36l4.82836,97.70322a81.21772,81.21772,0,0,1-62.338,83.02522L377.81538,317.338Z"
          />
          <path
            fill="#e59413"
            d="M393.06385,168.538l-15.24847,148.8s19.4169-1.467,20.93954-1.92442c17.05024-15.64062,26.75754-41.91973,24.444-65.26519l-9.29345-93.77942c-6.17029,2.53211-12.21875,4.72376-17.55018,6.52234C394.4,166.29129,393.06385,168.538,393.06385,168.538Z"
          />
          <path
            fill="#f9ae2b"
            d="M377.81538 168.538s16.56-27.84 18.48-36l11.65507 117.61031a74.05024 74.05024 0 01-30.135 67.18967l0 0zM377.81538 168.538s-47.28 3.36-88.08-14.4l2.70524 103.47537a54.06259 54.06259 0 0043.76165 51.66283l41.61311 8.0618z"
          />
          <path
            fill="#e59413"
            d="M377.81538 168.538c.82761 12.4 1.26059 24.8 1.55472 37.2.18427 6.2.22522 12.4.33362 18.6l.11046 18.6-.105 18.6c-.11151 6.2-.147 12.4-.33307 18.6-.293 12.4-.72809 24.8-1.56069 37.2-.83261-12.4-1.2677-24.8-1.5607-37.2-.18605-6.2-.22155-12.4-.33306-18.6l-.10505-18.6.11046-18.6c.1084-6.2.14936-12.4.33362-18.6C376.55478 193.338 376.98776 180.938 377.81538 168.538zM307.96693 189.493c5.04345.42658 9.98935 1.03365 14.93308 1.6145l14.77342 1.76915c4.91741.57886 9.8319 1.06214 14.7645 1.54462 4.9384.47008 9.87448.761 14.929 1.19174a70.35258 70.35258 0 01-15.02732 1.95194 109.63853 109.63853 0 01-15.12471-.71589 125.97344 125.97344 0 01-14.87588-2.65777A88.70831 88.70831 0 01307.96693 189.493zM307.96693 210.84843c5.04345.42658 9.98935 1.03363 14.93308 1.61451l14.77342 1.76915c4.91741.57884 9.8319 1.06213 14.7645 1.54461 4.9384.47007 9.87448.761 14.929 1.19173a70.35132 70.35132 0 01-15.02732 1.95195 109.64009 109.64009 0 01-15.12471-.71588 125.97346 125.97346 0 01-14.87588-2.65778A88.70733 88.70733 0 01307.96693 210.84843zM307.96693 232.20392c5.04345.42657 9.98935 1.03363 14.93308 1.6145l14.77342 1.76915c4.91741.57884 9.8319 1.06213 14.7645 1.54462 4.9384.47006 9.87448.761 14.929 1.19172a70.35132 70.35132 0 01-15.02732 1.95195A109.63852 109.63852 0 01337.2149 239.56a125.97753 125.97753 0 01-14.87588-2.65777A88.71026 88.71026 0 01307.96693 232.20392zM307.96693 253.5594c5.04345.42658 9.98935 1.03363 14.93308 1.6145l14.77342 1.76915c4.91741.57886 9.8319 1.06214 14.7645 1.54462 4.9384.47006 9.87448.761 14.929 1.19174a70.35258 70.35258 0 01-15.02732 1.95194 109.64009 109.64009 0 01-15.12471-.71588 125.98165 125.98165 0 01-14.87588-2.65778A88.70831 88.70831 0 01307.96693 253.5594zM307.96693 274.91489c5.04345.42657 9.98935 1.03363 14.93308 1.6145l14.77342 1.76913c4.91741.57886 9.8319 1.06214 14.7645 1.54462 4.9384.47009 9.87448.761 14.929 1.19174a70.35068 70.35068 0 01-15.02732 1.95194 109.64009 109.64009 0 01-15.12471-.71588 125.96937 125.96937 0 01-14.87588-2.65778A88.71018 88.71018 0 01307.96693 274.91489z"
          />
          <path
            fill="#ee781d"
            d="M449.17833 192.35061l-23.29673 3.92888a2 2 0 01-2.34444-1.58228l-.77263-16.82828a2 2 0 011.58228-2.34444l23.59568-4.84936a2 2 0 012.34444 1.58228l.47368 17.74877A2 2 0 01449.17833 192.35061zM435.95292 233.81126l-23.29673 3.92888a2 2 0 01-2.34444-1.58229l-.77263-16.82828a2 2 0 011.58228-2.34443l23.59568-4.84937a2 2 0 012.34444 1.58228l.47368 17.74877A2 2 0 01435.95292 233.81126z"
          />
          <path
            fill="#ce800d"
            d="M411.12141,216.98514a2,2,0,0,0-1.58228,2.34436l.77265,16.82837a2,2,0,0,0,2.34442,1.58227l9.16-1.5448L419.737,215.21451Z"
          />
          <path
            fill="#ee781d"
            d="M445.07114,275.2719l-23.29673,3.92888A2,2,0,0,1,419.43,277.6185l-.77264-16.82828a2,2,0,0,1,1.58229-2.34444l23.59568-4.84937a2,2,0,0,1,2.34444,1.58229l.47368,17.74877A2,2,0,0,1,445.07114,275.2719Z"
          />
          <path
            fill="#ce800d"
            d="M420.23963,258.44571a2.00008,2.00008,0,0,0-1.58227,2.34448l.77264,16.82837a1.98642,1.98642,0,0,0,.9953,1.35864,81.17976,81.17976,0,0,0,3.1004-21.20679Z"
          />
          <circle cx="312.04" cy="385.483" r="12.96" fill="#b9d4db" />
          <circle cx="294.76" cy="354.523" r="6.72" fill="#b9d4db" />
          <circle cx="338.718" cy="361.243" r="9.6" fill="#b9d4db" />
          <circle cx="174.129" cy="310.876" r="15.42" fill="#b9d4db" />
          <circle cx="144.663" cy="299.893" r="8.032" fill="#b9d4db" />
          <circle cx="152.041" cy="272.59" r="4.633" fill="#b9d4db" />
          <circle cx="177.688" cy="275.868" r="11.107" fill="#b9d4db" />
          <circle cx="271.185" cy="137.219" r="15.42" fill="#b9d4db" />
          <circle cx="271.811" cy="105.78" r="8.032" fill="#b9d4db" />
          <circle cx="325.309" cy="110.473" r="6.952" fill="#b9d4db" />
          <circle cx="300.018" cy="103.718" r="4.633" fill="#b9d4db" />
          <circle cx="305.402" cy="129.007" r="11.107" fill="#b9d4db" />
          <rect
            width="18.18"
            height="18.18"
            x="232.239"
            y="299.464"
            fill="#dbe8ec"
            transform="rotate(29.699 241.329 308.554)"
          />
          <path
            fill="#3086a3"
            d="M314.01052,301.09323A62.818,62.818,0,1,0,226.027,288.751,62.81434,62.81434,0,0,0,314.01052,301.09323Zm-78.20446-19.70585a50.58059,50.58059,0,1,1,70.83194,9.93131A50.58657,50.58657,0,0,1,235.80606,281.38738Z"
          />
          <circle
            cx="276.189"
            cy="250.935"
            r="50.58"
            fill="#fff"
            opacity=".76"
          />
          <path
            fill="none"
            stroke="#dbe8ec"
            strokeMiterlimit="10"
            strokeWidth="10"
            d="M312.30119,253.1553a36.18,36.18,0,0,1-67.87805,15.09763"
          />
          <rect
            width="33.12"
            height="78.675"
            x="200.798"
            y="311.244"
            fill="#3086a3"
            rx="2"
            transform="rotate(29.699 217.358 350.582)"
          />
          <path
            fill="#25788e"
            d="M213.24358,391.219l36.99731-64.866a1.99979,1.99979,0,0,0-.74642-2.7281l-6.2909-3.58808a2,2,0,0,1,.746,2.72791L206.95232,387.6306a1.99987,1.99987,0,0,1-2.7281.74641l6.29126,3.58835A1.99991,1.99991,0,0,0,213.24358,391.219Z"
          />
          <path
            fill="#409cb5"
            d="M190.55778,378.27966,227.555,313.41378a1.9999,1.9999,0,0,1,2.72814-.74637l6.98771,3.98549-13.07115-7.45534a2,2,0,0,0-2.72814.74636l-36.9973,64.866a2.00024,2.00024,0,0,0,.74635,2.72822l6.0835,3.46973A1.99993,1.99993,0,0,1,190.55778,378.27966Z"
          />
          <polygon
            fill="#409cb5"
            points="198.292 384.993 210.515 391.965 210.516 391.965 198.292 384.993"
          />
          <path
            fill="#dbe8ec"
            d="M177.53026,378.72715H213.034a2,2,0,0,1,2,2V386.669a13.17486,13.17486,0,0,1-13.17486,13.17486h-13.154A13.17486,13.17486,0,0,1,175.53026,386.669v-5.94182a2,2,0,0,1,2-2Z"
            transform="rotate(29.699 195.282 389.286)"
          />
          <path
            fill="#e8eeef"
            d="M185.40177,380.68282l2.94378-5.16128a2.00009,2.00009,0,0,1,2.72824-.74644l25.17612,14.35957a2.01862,2.01862,0,0,0-.3167-.22559l-30.84-17.59006a2.00017,2.00017,0,0,0-2.72824.74644l-2.94388,5.16135A13.175,13.175,0,0,0,184.338,395.1984l5.329,3.03939A13.16418,13.16418,0,0,1,185.40177,380.68282Z"
          />
          <path
            fill="#bad5db"
            d="M213.73568,396.79866l2.94389-5.16136a2.00023,2.00023,0,0,0-.74636-2.72822l-6.31823-3.60364a1.99956,1.99956,0,0,1,.74129,2.72455l-2.94378,5.16128a13.175,13.175,0,0,1-17.97168,4.91687l-5.11342-2.9165.0106.00676,11.42621,6.517A13.17469,13.17469,0,0,0,213.73568,396.79866Z"
          />
        </svg>
      );
    default:
      return <div></div>;
  }
}
